module.exports = __webpack_public_path__ + "fda3ae60e1bb70fb8efa03cc804402e0.svg";